var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { LIFE_CYCLE_TYPE, } from '../type';
import { Cycle } from './cycle';
import { computed, readonly, ref, shallowReactive } from '@vue/reactivity';
import { clone, isFn, isValid } from '@ecom-zform/shared';
import { DEFAULT_FORM_STATE, getState, ROOT_VALUE_PATH } from '../shared';
import { buildEffects, buildGetAllChildren, buildInitialize, buildMakeCommonWatch, buildNode, buildNodeArray, buildReset, buildSetExtra, buildSetState, buildValidate, buildValidateValue, buildValidateWithAllChildren, getStateWithAllChildren, unshiftRootValueAddressToFormAddress, } from '../shared/internal';
import { buildWatchStateChange } from '../shared/watch-state';
import { getIn, setIn } from '../shared/path';
export var createForm = function (props, options) { return new FormRoot(props, options); };
var FormRoot = /** @class */ (function () {
    function FormRoot(props, options) {
        var _a;
        var _this = this;
        if (props === void 0) { props = {}; }
        if (options === void 0) { options = {}; }
        // props: IFormRootProps<V>;
        this.cycle = new Cycle();
        this.field = '';
        this.address = {
            arr: [],
            string: '',
        };
        this.root = this;
        this.uuidCount = ref(0);
        this.uuid = this.releaseUUID();
        this.watchStopFunList = [];
        this.__visibleReasonLog = true;
        this.label = ref(DEFAULT_FORM_STATE.label);
        this.tooltip = ref(DEFAULT_FORM_STATE.tooltip);
        this.placeholder = ref(DEFAULT_FORM_STATE.placeholder);
        this.visible = ref(DEFAULT_FORM_STATE.visible);
        this.loading = ref(DEFAULT_FORM_STATE.loading);
        this.disabled = ref(DEFAULT_FORM_STATE.disabled);
        this.description = ref(DEFAULT_FORM_STATE.description);
        this.extraRef = ref({});
        this.initialized = ref(DEFAULT_FORM_STATE.initialized);
        this.modified = ref(DEFAULT_FORM_STATE.modified);
        this.required = ref(DEFAULT_FORM_STATE.required);
        this.validateFirst = ref(DEFAULT_FORM_STATE.validateFirst);
        this.rules = ref(DEFAULT_FORM_STATE.rules);
        this.error = ref(DEFAULT_FORM_STATE.error);
        this.disableValidate = ref(DEFAULT_FORM_STATE.disableValidate);
        this.validating = ref(DEFAULT_FORM_STATE.validating);
        // component: Ref<IComponent | undefined> = ref(undefined);
        this.decorator = ref(undefined);
        this.rootValueContainer = ref((_a = {}, _a[ROOT_VALUE_PATH] = undefined, _a));
        this.getAllChildren = function () { return _this.allChildren; };
        this.n = this.node;
        this.na = this.nodeArray;
        this.children = shallowReactive({});
        if (options.visibleReasonLog === false)
            this.__visibleReasonLog = false;
        this.initialValue = ref(isValid(props.initialValue) ? props.initialValue : DEFAULT_FORM_STATE.initialValue);
        this.value = computed({
            get: function () { return getIn(unshiftRootValueAddressToFormAddress(_this.address), _this.root.rootValueContainer.value); },
            set: function (val) {
                setIn(unshiftRootValueAddressToFormAddress(_this.address), _this.root.rootValueContainer.value, val);
                __spreadArray(__spreadArray([], __read(_this.allParent)), __read(_this.allChildren)).forEach(function (form) {
                    form.publish(LIFE_CYCLE_TYPE.ON_VALUE_CHANGE);
                });
                _this.publish(LIFE_CYCLE_TYPE.ON_VALUE_CHANGE);
            },
        });
        this.value.value = isValid(props.value) ? props.value : clone(this.initialValue.value);
        this._makeWatch();
    }
    FormRoot.prototype._makeWatch = function () {
        buildMakeCommonWatch(this);
    };
    FormRoot.prototype.initialize = function (props) {
        buildInitialize(this, props);
    };
    Object.defineProperty(FormRoot.prototype, "state", {
        get: function () {
            return readonly(getState(this));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormRoot.prototype, "extra", {
        get: function () {
            return readonly(this.extraRef.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormRoot.prototype, "allChildren", {
        get: function () {
            return buildGetAllChildren(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormRoot.prototype, "allParent", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 获取所有子节点的状态，可以通过传入 StateType 来获取不同的类型的值
     */
    FormRoot.prototype.getStateWithAllChildren = function (stateType) {
        return readonly(getStateWithAllChildren(this, stateType));
    };
    FormRoot.prototype.releaseUUID = function () {
        return this.uuidCount.value++;
    };
    /**
     * ⭐️⭐️⭐️
     * 设置表单节点状态，必须传入修改原因
     * 注：传入修改看起来是比较麻烦，但是在我们 debug 表单状态时会非常有用，
     *    后续会在表单 Devtools 中根据 reason 记录表单状态
     */
    FormRoot.prototype.setState = function (payload, reason) {
        return buildSetState(this, payload, reason);
    };
    FormRoot.prototype.setValue = function (payload, reason) {
        return this.setState({
            value: isFn(payload) ? payload(this.state.value) : payload,
        }, reason);
    };
    FormRoot.prototype.setExtra = function (payload, reason) {
        return buildSetExtra(this, payload, reason);
    };
    FormRoot.prototype.watchState = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return buildWatchStateChange.apply(void 0, __spreadArray([this], __read(params)));
    };
    /**
     * 订阅表单生命周期，比较底层的 API，React 中的 useFormEffects 就是基于这个 API 实现的，
     * 如果你在 React 组件中，可以直接使用 useFormEffects
     */
    FormRoot.prototype.effects = function (listeners, options) {
        if (options === void 0) { options = {}; }
        return buildEffects(this, listeners, options);
    };
    // node method cannot create Array Type node
    FormRoot.prototype.node = function (path) {
        return buildNode(this, this.root, path);
    };
    // nodeArray method must create Array Type node
    FormRoot.prototype.nodeArray = function (path) {
        return buildNodeArray(this, this.root, path);
    };
    FormRoot.prototype.publish = function (type, payload) {
        this.cycle.publish(this, type, payload || this);
    };
    /**
     * 校验节点自己
     * @param trigger 当传入 trigger 时会根据 trigger 对规则进行筛选
     */
    FormRoot.prototype.validate = function (trigger) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, buildValidate(this, trigger)];
            });
        });
    };
    /**
     * 校验自己 + 所有父节点
     *
     * 相关文档：
     * https://zform.bytedance.net/v2/docs/guide/quick-start/validate#%E6%A0%A1%E9%AA%8C%E8%BF%9B%E9%98%B6
     *
     * @param trigger
     */
    FormRoot.prototype.validateWithAllParent = function (trigger) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.validate(trigger)]).then(function (errorList) {
                            return errorList.filter(function (v) { return v && v.status === 'error'; });
                        })];
                    case 1:
                        res = _a.sent();
                        // this.publish(LIFE_CYCLE_TYPE.ON_VALIDATE_WITH_ALL_PARENT_END);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 校验自己 + 所有子节点
     *
     * 相关文档：
     * https://zform.bytedance.net/v2/docs/guide/quick-start/validate#%E6%A0%A1%E9%AA%8C%E8%BF%9B%E9%98%B6
     *
     * @param trigger
     */
    FormRoot.prototype.validateWithAllChildren = function (trigger) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, buildValidateWithAllChildren(this, trigger)];
            });
        });
    };
    /**
     * ⭐️ 常用
     * 校验自己 + 所有子节点（详细可以查看 表单校验-校验表单节点-validateValue)
     * 校验成功 resolve value / 校验失败 reject errorInfo
     * @param trigger
     */
    FormRoot.prototype.validateValue = function (trigger) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, buildValidateValue(this, trigger)];
            });
        });
    };
    /**
     * 对表单状态进行重置
     * 1. 将表单值重置为 initialValue
     * 2. 将自身 + 所有子节点的 state.modified 设置为 false
     * 3. 清除自身 + 所有子节点的错误信息
     * @param options
     */
    FormRoot.prototype.reset = function (options) {
        if (options === void 0) { options = {
            validate: false,
        }; }
        return buildReset(this, options);
    };
    return FormRoot;
}());
export { FormRoot };
